"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInput = exports.TagNameReadonlyInput = void 0;
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var highlighter_1 = require("../../services/util/highlighter");
var key_binding_1 = require("../../services/util/key.binding");
var tag_name_input_style_1 = require("./tag.name.input.style");
(0, theme_1.addStyles)(tag_name_input_style_1.Style);
exports.TagNameReadonlyInput = {
    view: function (ctrl) {
        var tag = ctrl.tag;
        var attributes = {
            className: tag_name_input_style_1.CSS.link,
            onclick: function (_) { return ctrl.zoomToTag(); }
        };
        var timeString = services_1.Services.DateTime.formatDateTime(tag.updatedAt);
        var tagNameChildren = tag.name;
        var filterValue = ctrl.getTagFilterValue();
        if (filterValue != null && filterValue.length > 0) {
            tagNameChildren = highlighter_1.Highlighter.highlight(tag.name, filterValue).parts
                .map(function (part) { return (0, mithril_1.m)('span', { className: part.highlighted ? tag_name_input_style_1.CSS.filterMatch : undefined }, part.content); });
        }
        return (0, mithril_1.m)('div', attributes, [
            (0, mithril_1.m)('span', { className: tag_name_input_style_1.CSS.title, title: tag.name }, tagNameChildren),
            (0, mithril_1.m)('div', { className: tag_name_input_style_1.CSS.date, title: (0, index_1.Translate)(index_1.T.LAST_UPDATED_AT, { timeString: timeString }) }, timeString)
        ]);
    }
};
exports.TagNameInput = {
    view: function (ctrl, autoCompleteMenu) {
        var _a;
        var KeyEvents = (_a = {},
            _a[key_binding_1.KeyCode.ESCAPE] = function () { return ctrl.cancelEdit(); },
            _a[key_binding_1.KeyCode.ENTER] = function () { return ctrl.acceptEdit(); },
            _a);
        var tagNameChildren = (0, mithril_1.m)('input', {
            className: tag_name_input_style_1.CSS.linkEditable,
            spellcheck: false,
            value: ctrl.getInputValue(),
            onkeyup: key_binding_1.KeyCode.bind(KeyEvents),
            oninput: function (e) { return ctrl.updateEdit(e.target.value); },
            oncreate: function (vnode) { return exports.TagNameInput.startEdit(vnode, ctrl); },
            onfocus: function () { return ctrl.getInputState().setFocused(true); },
            onblur: function () { return ctrl.getInputState().setFocused(false); }
        });
        var acceptButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CHECK, {
            type: 'button',
            onclick: function (e) {
                e.stopPropagation();
                ctrl.acceptEdit();
            }
        });
        var cancelButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            type: 'button',
            onclick: function (e) {
                e.stopPropagation();
                ctrl.cancelEdit();
            }
        });
        return (0, mithril_1.m)('div', { className: tag_name_input_style_1.CSS.container }, [
            tagNameChildren,
            autoCompleteMenu.view(),
            acceptButton,
            cancelButton
        ]);
    },
    startEdit: function (vnode, ctrl) {
        var _a;
        var element = vnode.dom;
        var tagCard = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (!tagCard) {
            services_1.Logger.error("Cannot find Tag Card of ".concat(element));
            return;
        }
        var handleClickAway = function () {
            ctrl.tagCard = tagCard;
            ctrl.cancelEdit();
        };
        services_1.Services.FocusAway.from(tagCard, handleClickAway);
        element.focus();
        element.select();
    }
};
//# sourceMappingURL=tag.name.input.js.map